<template>
  <div class="steps">
    <!-- Legal -->
    <div class="header-step-container">
      <a
        @click="go(MENUS.CLIENT.CITIZENSHIP.id)"
        class="step-icon"
        @mouseover="showLegalHover = true"
        @mouseout="showLegalHover = false"
        :class="legalData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-balance-scale"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="go(MENUS.CLIENT.CITIZENSHIP.id)"
        :class="legalData.tooltipClass"
      >
        Legal Stuff
        <span class="completion-text"> ({{ legalData.stepsComplete }}/3) </span>
      </div>
    </div>

    <!-- Basic Info -->
    <div class="header-step-container">
      <a
        @click="go(MENUS.CLIENT.SSN.id)"
        class="step-icon"
        @mouseover="showBasicHover = true"
        @mouseout="showBasicHover = false"
        :class="basicData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-tasks"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="go(MENUS.CLIENT.SSN.id)"
        :class="basicData.tooltipClass"
      >
        Basic Info
        <span class="completion-text"> ({{ basicData.stepsComplete }}/3) </span>
      </div>
    </div>

    <!-- Employment Info -->
    <div class="header-step-container">
      <a
        @click="goToEmployment()"
        class="step-icon"
        @mouseover="showEmploymentHover = true"
        @mouseout="showEmploymentHover = false"
        :class="employmentData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-briefcase"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="goToEmployment()"
        :class="employmentData.tooltipClass"
      >
        Employment
        <span class="completion-text">
          ({{ employmentData.stepsComplete }}/{{ totalEmploymentSteps }})
        </span>
      </div>
    </div>

    <!-- Trust & Entity Accounts -->
    <div class="header-step-container" v-if="canShowTrustEntity">
      <a
        @click="goToTrustEntity()"
        class="step-icon"
        @mouseover="showTrustEntityHover = true"
        @mouseout="showTrustEntityHover = false"
        :class="trustEntityData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-building"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="goToTrustEntity()"
        :class="trustEntityData.tooltipClass"
      >
        Trust & Entity
        <span class="completion-text">
          ({{ trustEntityData.stepsComplete }}/{{ totalTrustEntitySteps }})
        </span>
      </div>
    </div>

    <!-- Beneficiary Info -->
    <div class="header-step-container" v-if="canDesignateBeneficiaries">
      <a
        @click="go(firstBeneficiaryRoute)"
        class="step-icon"
        @mouseover="showBeneficiaryHover = true"
        @mouseout="showBeneficiaryHover = false"
        :class="beneficiaryData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-user-plus"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="go(firstBeneficiaryRoute)"
        :class="beneficiaryData.tooltipClass"
      >
        Beneficiaries
        <span class="completion-text">
          ({{ beneficiaryData.stepsComplete }}/{{ totalBeneficiarySteps }})
        </span>
      </div>
    </div>

    <!-- Decedent Info (Inherited IRA) -->
    <div class="header-step-container" v-if="canShowDecedent">
      <a
        @click="go(firstDecedentRoute)"
        class="step-icon"
        @mouseover="showDecedentHover = true"
        @mouseout="showDecedentHover = false"
        :class="decedentData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-user-injured"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="go(firstDecedentRoute)"
        :class="decedentData.tooltipClass"
      >
        Decedents
        <span class="completion-text">
          ({{ decedentData.stepsComplete }}/{{ totalDecedentSteps }})
        </span>
      </div>
    </div>

    <!-- Custom Questions -->
    <div class="header-step-container" v-if="hasCustomQuestions">
      <a
        @click="go(firstCustomQuestionRoute)"
        class="step-icon"
        @mouseover="showCustomQuestionsHover = true"
        @mouseout="showCustomQuestionsHover = false"
        :class="customQuestionsData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-question-circle"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="go(firstCustomQuestionRoute)"
        :class="customQuestionsData.tooltipClass"
      >
        Other Questions
        <span class="completion-text">
          ({{ customQuestionsData.stepsComplete }}/{{ totalCustomQuestions }})
        </span>
      </div>
    </div>

    <!-- Remaining Data -->
    <div class="header-step-container">
      <a
        @click="go(MENUS.CLIENT.FINISH.id)"
        class="step-icon"
        @mouseover="showRemainingHover = true"
        @mouseout="showRemainingHover = false"
        :class="remainingData.iconClass"
      >
        <div class="step-icon-inner">
          <i class="fas fa-clipboard-list"></i>
        </div>
      </a>
      <div
        class="step-hover-text"
        @click="go(MENUS.CLIENT.FINISH.id)"
        :class="remainingData.tooltipClass"
      >
        Remaining
        <span class="completion-text empty"> </span>
      </div>
    </div>
  </div>
</template>
<script>
import ClientMixin from '@/common/mixins/unauthenticated.client.mixin';
import { EventService } from '@/services/event.service';
import { MENUS } from '@/common/constants';

export default {
  name: 'MainMenu',

  mixins: [ClientMixin],

  components: {},

  data: () => ({
    MENUS: MENUS,
    showLegalHover: false,
    showBasicHover: false,
    showEmploymentHover: false,
    showBeneficiaryHover: false,
    showRemainingHover: false,
    showCustomQuestionsHover: false,
    showDecedentHover: false,
    showTrustEntityHover: false,
  }),

  computed: {
    legalData() {
      let d = {
        tooltipClass: this.showLegalHover ? 'show' : '',
        stepsComplete: this.legalCompletionSteps,
      };
      d.iconClass = this.isLegalComplete ? 'complete' : 'empty';
      if (this.isLegalRoute) d.iconClass += ' current';
      return d;
    },
    basicData() {
      let d = {
        tooltipClass: this.showBasicHover ? 'show' : '',
        stepsComplete: this.basicCompletionSteps,
      };
      d.iconClass = this.isBasicComplete ? 'complete' : 'empty';
      if (this.isBasicRoute) d.iconClass += ' current';
      return d;
    },
    employmentData() {
      let d = {
        tooltipClass: this.showEmploymentHover ? 'show' : '',
        stepsComplete: this.employmentCompletionSteps,
      };
      d.iconClass = this.isEmploymentComplete ? 'complete' : 'empty';
      if (this.isEmploymentRoute) d.iconClass += ' current';
      return d;
    },
    beneficiaryData() {
      let d = {
        tooltipClass: this.showBeneficiaryHover ? 'show' : '',
        stepsComplete: this.beneficiaryCompletionSteps,
      };
      d.iconClass = this.isBeneficiaryComplete ? 'complete' : 'empty';
      if (this.isBeneficiaryRoute) d.iconClass += ' current';
      return d;
    },
    remainingData() {
      let d = {
        tooltipClass: this.showRemainingHover ? 'show' : '',
        stepsComplete: this.remainingCompletionSteps,
      };
      d.iconClass = this.isRemainingComplete ? 'complete' : 'empty';
      if (this.isFinishRoute) d.iconClass += ' current';
      return d;
    },
    customQuestionsData() {
      let d = {
        tooltipClass: this.showCustomQuestionsHover ? 'show' : '',
        stepsComplete: this.customQuestionsCompletionSteps,
      };
      d.iconClass = this.areCustomQuestionsComplete ? 'complete' : 'empty';
      if (this.isCustomQuestionsRoute) d.iconClass += ' current';
      return d;
    },
    decedentData() {
      let d = {
        tooltipClass: this.showDecedentHover ? 'show' : '',
        stepsComplete: this.decedentCompletionSteps,
      };
      d.iconClass = this.isDecedentComplete ? 'complete' : 'empty';
      if (this.isDecedentRoute) d.iconClass += ' current';
      return d;
    },
    trustEntityData() {
      let d = {
        tooltipClass: this.showTrustEntityHover ? 'show' : '',
        stepsComplete: this.trustEntityCompletionSteps,
      };
      d.iconClass = this.isTrustEntityComplete ? 'complete' : 'empty';
      if (this.isTrustEntityRoute) d.iconClass += ' current';
      return d;
    },
    canShowTrustEntity() {
      return this.totalTrustEntitySteps > 0;
    },
    totalTrustEntitySteps() {
      return this.totalTrustAccountSteps + this.totalEntityAccountSteps;
    },
    trustEntityCompletionSteps() {
      return this.trustAccountCompletionSteps + this.entityAccountCompletionSteps;
    },
    isTrustEntityComplete() {
      return this.isTrustAccountsComplete && this.isEntityAccountsComplete;
    },
    isTrustEntityRoute() {
      return this.isTrustAccountRoute || this.isEntityAccountRoute;
    },
    hasCustomQuestions() {
      return this.clientProgress && 
             this.clientProgress.progress && 
             this.clientProgress.progress.some(page => 
               page.pageName === MENUS.CLIENT.CUSTOM_QUESTIONS.id
             );
    },
    totalCustomQuestions() {
      if (!this.clientProgress || !this.clientProgress.progress) return 0;
      return this.clientProgress.progress.filter(
        page => page.pageName === MENUS.CLIENT.CUSTOM_QUESTIONS.id
      ).length;
    },
    customQuestionsCompletionSteps() {
      if (!this.clientProgress || !this.clientProgress.progress) return 0;
      return this.clientProgress.progress.filter(
        page => page.pageName === MENUS.CLIENT.CUSTOM_QUESTIONS.id && 
               page.lastCompleted && 
               page.status === 'SYNCED'
      ).length;
    },
    firstCustomQuestionRoute() {
      if (!this.clientProgress || !this.clientProgress.progress) return null;
      
      const customQuestions = this.clientProgress.progress.filter(
        page => page.pageName === MENUS.CLIENT.CUSTOM_QUESTIONS.id
      );
      
      if (customQuestions.length === 0) return null;
      
      // Find first incomplete question or just the first one
      const firstIncomplete = customQuestions.find(
        q => !q.lastCompleted || q.status !== 'SYNCED'
      );
      
      const questionToUse = firstIncomplete || customQuestions[0];
      
      return {
        name: MENUS.CLIENT.CUSTOM_QUESTIONS.id,
        params: { questionId: questionToUse.data.question._id }
      };
    },
    isCustomQuestionsRoute() {
      return this.$route.name === MENUS.CLIENT.CUSTOM_QUESTIONS.id;
    }
  },

  methods: {
    // Emit event indicating navigation to a page
    go(route) {
      if (typeof route === 'object') {
        EventService.emit('navigate-to-params', route);
      } else {
        EventService.emit('navigate-to', route);
      }
    },
    
    // Navigate to the appropriate employment page
    goToEmployment() {
      // Check which employment page exists in template
      const hasEmploymentStatus2 = this.getPage(MENUS.CLIENT.EMPLOYMENT_STATUS_2.id) !== undefined;
      const hasEmploymentStatus = this.getPage(MENUS.CLIENT.EMPLOYMENT_STATUS.id) !== undefined;
      
      if (hasEmploymentStatus2) {
        this.go(MENUS.CLIENT.EMPLOYMENT_STATUS_2.id);
      } else if (hasEmploymentStatus) {
        this.go(MENUS.CLIENT.EMPLOYMENT_STATUS.id);
      } else {
        // Default to employment status if neither exists
        this.go(MENUS.CLIENT.EMPLOYMENT_STATUS.id);
      }
    },
    
    // Navigate to the first Trust or Entity page
    goToTrustEntity() {
      // Find first incomplete trust account page
      const firstIncompleteTrust = this.firstTrustAccountRoute;
      const firstIncompleteEntity = this.firstEntityAccountRoute;
      
      // If we have an incomplete trust page, go there
      if (firstIncompleteTrust) {
        this.go(firstIncompleteTrust);
      } 
      // Otherwise if we have an incomplete entity page, go there
      else if (firstIncompleteEntity) {
        this.go(firstIncompleteEntity);
      }
      // Otherwise just go to the first trust account if it exists
      else if (this.canShowTrustAccount) {
        this.go(this.firstTrustAccountRoute);
      }
      // Otherwise go to the first entity account
      else if (this.canShowEntityAccount) {
        this.go(this.firstEntityAccountRoute);
      }
    },
  },

  created() {},
};
</script>

<style lang="scss" scoped>
.steps {
  z-index: 100000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1263px) {
    flex-direction: column;
    align-items: stretch;
  }
}
.header-step-container {
  position: relative;
  display: flex;
  margin-right: 10px;
  margin-left: 10px;
  flex-direction: column;
  align-items: center;
}

.step-icon {
  position: relative;
  z-index: 1;
  display: flex;
  width: 40px;
  height: 40px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--primary-color);
  transition: all 200ms ease;
  color: var(--color-text-dark);

  &.empty {
    background-color: var(--label-text);
  }

  &.complete {
    .step-icon-inner {
      background-color: var(--primary-color);
      color: var(--color-white);
    }
  }

  &.disabled {
    background-color: var(--secondary-color);
    cursor: not-allowed;

    .step-icon-inner {
      color: var(--secondary-color);
      background-color: var(--color-white);
    }
  }

  &.current {
    .step-icon-inner {
      color: var(--primary-color);
      background-color: var(--color-white);
    }
    background-color: var(--primary-color);
  }

  .step-icon-inner {
    position: absolute;
    left: auto;
    top: auto;
    right: auto;
    bottom: auto;
    z-index: 3;
    display: flex;
    width: 85%;
    height: 85%;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: var(--color-white);
    color: var(--label-text);
  }
}

.bullet-number {
  position: absolute;
  left: auto;
  top: 1px;
  right: 7px;
  bottom: auto;
  z-index: 4;
  font-family: Caveat, sans-serif;
  font-size: 12px;
  font-weight: 700;
}
.step-hover-text {
  position: absolute;
  left: auto;
  right: auto;
  bottom: -140%;
  display: flex;
  padding-top: 50px;
  flex-direction: column;
  font-family: Roboto, sans-serif;
  color: var(--color-text-dark);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;

  &.show {
    opacity: 1;
  }

  .completion-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    line-height: 12px;

    &.empty {
      min-height: 12px;
    }
  }
}

@media screen and (max-width: 1263px) {
  .step-hover-text {
    position: relative;
    bottom: auto;
    padding-top: 0px;
    font-size: 16px;
    opacity: 1;
  }
  .steps {
    flex-direction: column;
    align-items: stretch;
  }
  .header-step-container {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row;
    align-items: center;
  }
  .step-icon {
    overflow: hidden;
    width: 50px;
    height: 50px;
    margin-right: 15px;
    margin-bottom: 0px;
    margin-left: 0px;
    font-size: 24px;
  }
  .completion-text {
    align-items: start !important;
    font-weight: 400;
  }
}
</style>
